import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { links, constants } from 'common/helpers'
import { FormattedMessage, FormattedHTMLMessage } from 'sb-react-intl'
import actions from 'redux/actions'

import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'

import messages from './messages'
import s from './CardUpdateSuccessModal.scss'

import birdImage from './images/bird-bike.svg'


class CardUpdateSuccessModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object,
  }

  static defaultProps = {
    name: constants.modals.CardUpdateSuccess,
  }

  constructor() {
    super()

    this.interval = null

    this.state = {
      timeLeft: 5,
    }
  }

  componentDidMount() {
    this.interval = setInterval(this.tick, 1000)
  }

  tick = () => {
    let { timeLeft } = this.state

    this.setState({
      timeLeft: --timeLeft,
    })

    if (!timeLeft) {
      clearInterval(this.interval)
      this.closeModalAndRedirect()
    }
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  closeModalAndRedirect = () => {
    this.close()

    actions.models.router.push(links.subscription.smartSearch)
  }

  render() {
    const { timeLeft } = this.state
    const { name, data: { month, isPayPalUpdate } } = this.props

    return (
      <Modal
        className={s.cardUpdateSuccess}
        titleClassName={s.title}
        contentClassName={s.content}
        name={name}
        title={isPayPalUpdate ? messages.payPalTitle : messages.title}
        disableClose
      >
        <img src={birdImage} alt="" />
        <div>
          <FormattedHTMLMessage
            className={s.text}
            tag="div"
            values={{ month }}
            {...messages.text}
          />
          <Button
            brand
            className={s.button}
            title={messages.button}
            onClick={this.closeModalAndRedirect}
          />
          <FormattedMessage
            tag="div"
            className={s.textRedirect}
            values={{ timeLeft: String(timeLeft) }}
            {...messages.redirect}
          />
        </div>
      </Modal>
    )
  }
}


export default CardUpdateSuccessModal
